import styled from "styled-components";

export const ConsoleEmailTemplateTableContainer = styled.div`
  #admin-console-view_template {
    padding: 0.5rem;

    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.console.modalHover}b3;
    }

    svg * {
      fill: ${({ theme }) => theme.console.pageTitleColor};
    }
  }
`;
